import React from "react";
import "../../../css/StatCard.css";
import useRequestDetailedData from "../../../utils/useRequestDetailedData";

const StatCard = ({ item }) => {
    const {
        requestResponseData,
        loading,
        error,
    } = useRequestDetailedData(item.requestId, item, true);

    if (loading) {
        return <div className="stat-card">Loading...</div>;
    }

    if (error) {
        return <div className="stat-card error">{error}</div>;
    }

    // If `requestResponseData` is an object with key-value pairs
    const cards = Object.entries(requestResponseData || {}).map(([key, value]) => (
        <div className="stat-card w-100 m-0 h-100" key={key}>
            <div className="stat-card-content">
                <div className="stat-card-text">
                    <p>{key}</p> {/* Display the key as the name */}
                    <h2>{value}</h2> {/* Display the value */}
                </div>
                <div className="stat-card-icon">
                    <img
                        src="https://icons.veryicon.com/png/o/education-technology/basic-navigation-class-of-data-application/total-number-of-users.png"
                        alt="Stat Icon"
                    />
                </div>
            </div>
        </div>
    ));

    return <div className="stat-card-container w-100 m-0 h-100">{cards}</div>; // Wrap all cards in a container
};

export default StatCard;
